import { useContext, useState } from "react";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  CardOrden,
  ContainerModalCentro,
  ContainerP5,
} from "./localStyle";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { PortalContext } from "_+_Portal/context/Provider";
import TurnoNoEncontrado from "_+_Portal/components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import { FaMapMarkerAlt } from "react-icons/fa";
import InformacionIcon from "_+_Portal/assets/images/generico/InformacionIcon";
import { getLocalStorage, getSessionStorage } from "global/utils/safeJsonParse";

const OtroCentro = () => {
  // -------------------------  useContex  ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const { ordenDigitalDispatch } = useContext(PortalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  const idTerminal = getLocalStorage("idTerminal");
  const centro = getSessionStorage("otroCentro");
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const volver = () => {
    sessionStorage.removeItem("otroCentro");
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    setPaso("DemandaEspontanea")(pasoDispatch);
  };

  const handleComoLlegar = () => {
    if (centro) {
      const url = `https://www.google.com/maps/dir/?api=1&destination=${centro?.centroDto?.coordenadaGps}&dir_action=navigate&travelmode=walking`;
      window.open(url, "_blank");
    }
  };

  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={() => volver()}
        title={"Turno en otra sede"}
        subtitle={""}
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5>
              <div className="ptur-turnoNoEncontrado-noEcontrados-icono">
                <InformacionIcon />
              </div>
              <ContainerModalCentro>
                {idTerminal ? (
                  <>
                    <p className="rb18l text-center">
                      Estás en una sede diferente a la del turno seleccionado.
                      Dirigite a la sede seleccionada para comenzar con el
                      proceso de recepción.
                    </p>
                    <p className="rb18m">Sede seleccionada:</p>
                    <p className="rb18m">{centro?.centro}</p>
                    <div className="container-direccion">
                      <FaMapMarkerAlt
                        color={"var(--color-latex30)"}
                        size={30}
                      />{" "}
                      <p className="rb18m">{centro?.direccion}</p>
                    </div>
                  </>
                ) : (
                  <>
                    <p>
                      Estás en una sede diferente a la del turno. Para poder
                      recepcionarte, seguí estos pasos:
                    </p>
                    <p>
                      1) Tocá "¿Cómo llegar?" para ver la ubicación.
                      <br />
                      2) Cuando llegues, escaneá el código QR para comenzar la
                      recepción.
                    </p>
                    <span
                      className="bold btn-como-llegar"
                      onClick={handleComoLlegar}
                    >
                      <FaMapMarkerAlt
                        color={"var(--color-latex30)"}
                        size={20}
                      />{" "}
                      ¿Cómo llegar?
                    </span>
                  </>
                )}
              </ContainerModalCentro>
              <ButtonP5 onClick={() => volver()}>Volver</ButtonP5>
            </BodyContainerP5>
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default OtroCentro;
